import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export interface SiteHeroCta {
  label: string;
  to: string;
}

export interface SiteHeroProps {
  title: string;
  subtitle: string;
  titleId?: string;
  primaryCta?: SiteHeroCta;
  primaryAction?: React.ReactNode;
  secondaryAction?: React.ReactNode;
  badges?: React.ReactNode;
  visual?: React.ReactNode;
  centered?: boolean;
}

export const SiteHero: React.FC<SiteHeroProps> = ({
  title,
  subtitle,
  titleId = 'io-site-hero-title',
  primaryCta,
  primaryAction,
  secondaryAction,
  badges,
  visual,
  centered = false,
}) => {
  return (
    <section
      className={`io-site-hero${centered ? ' io-site-hero--centered' : ''}`}
      aria-labelledby={titleId}
    >
      <div className="io-site-hero__tiles" aria-hidden />
      <div className="io-site-hero__grid-lines" aria-hidden />
      <div className="io-site-hero__inner">
        <div className="io-site-hero__content">
          <div className="io-site-hero__head">
            <h1 id={titleId} className="io-site-hero__title">
              {title}
            </h1>
            <p className="io-site-hero__subtitle">{subtitle}</p>
          </div>
          {badges ? <div className="io-site-hero__badges">{badges}</div> : null}
          {(primaryAction || primaryCta || secondaryAction) && (
            <div className="io-site-hero__actions">
              {primaryAction ??
                (primaryCta ? (
                  <Link to={primaryCta.to} className="io-site-hero__cta">
                    {primaryCta.label}
                    <ArrowRight className="io-site-hero__cta-arrow" size={22} strokeWidth={2} aria-hidden />
                  </Link>
                ) : null)}
              {secondaryAction}
            </div>
          )}
        </div>
        {visual ? <div className="io-site-hero__visual">{visual}</div> : null}
      </div>
    </section>
  );
};
